import { CheckboxCard } from "shared/components/forms/CheckboxCard";

export const YesNoPreview = ({
  options,
  selected,
  onSelect
}: {
  options: string[];
  selected: string;
  onSelect: (value: string) => void;
}) => {
  return (
    <div className="flex gap-2 items-center w-full">
      {options.map((opt) => (
        <CheckboxCard
          key={opt}
          id={`preview-${opt}`}
          name="yes-no-preview"
          checked={selected === opt}
          onChange={() => onSelect(opt)}
          label={opt}
          wrapperClassName="w-full"
        />
      ))}
    </div>
  );
};
